import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import PageHeader from '../../components/PageHeader'
import { FaEye } from 'react-icons/fa'
import { ToastContainer, toast } from 'react-toastify'
import  FieldVisitService  from '../../services/FieldVisitService'
import Filters from '../../components/Filters'
import Pagination from '../../components/Pagination'

const ListFieldVisit = () => {
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])
    const [error, setError] = useState('')
    const [alert, setAlert] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(20)
    const [searchTerm, setSearchTerm] = useState('')
    const [filterFields, setFilterFields] = useState([])
    const [offset, setOffset] = useState(0)
    const [filters, setFilters] = useState({})
    const [appliedFilters, setAppliedFilters] = useState({})

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
        setCurrentPage(1)
    }

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(event.target.value)
        setCurrentPage(1)
    }
    const handleApplyFilters = (filters) => {
        setAppliedFilters(filters)
        setCurrentPage(1)
    }
    const handleEditClick = (row) => {
        // Handle edit click logic here
        console.log('Edit clicked for row:', row)
    }
  return (
     <>
                <AppSidebar />
                <div className="main-content">
                    <AppHeader title='Field Visits' />
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-12 ">
                                <PageHeader title="Field Visits" button_label="Create" link_to="create" className="btn btn-sm btn-primary" />
                                {alert && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        <strong> {error}!</strong>
                                        <button type="button" onClick={() => setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                    </div>
                                )}
                                <div className="tab-content">
                                    <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                                        <div className="card">
                                        <div className="card-header">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <form>
                                                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                                <input
                                                                    className="form-control list-search"
                                                                    type="text"
                                                                    placeholder="Search"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                />
                                                                <span className="input-group-text">
                                                                    <i className="fe fe-search" />
                                                                </span>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="col-auto me-n3">
                                                        <form>
                                                            <select
                                                                className="form-select form-select-sm form-control-flush"
                                                                value={itemsPerPage}
                                                                onChange={handleItemsPerPageChange}
                                                            >
                                                                <option value="20">20 per page</option>
                                                                <option value="40">40 per page</option>
                                                                <option value="60">60 per page</option>
                                                                <option value="100">100 Records</option>
                                                            </select>
                                                        </form>
                                                    </div>
                                                    <div className="col-auto">
                                                    <Filters filterFields={filterFields} onApplyFilters={handleApplyFilters} getFilterService={FieldVisitService.getPlansFilter} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                {loading && (
                                                    <div className="text-center">Loading...</div>
                                                )}
                                                <table className="table table-sm table-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Customer Name</th>
                                                            <th scope="col">Employee Name</th>
                                                            <th scope="col">Visit Date</th>
                                                            <th scope="col">Purpose</th>
                                                            <th scope="col">Remark</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(rows) && rows.length > 0 ? (
                                                            rows.map((row, index) => (
                                                                <tr key={row.id}>
                                                                    <th scope="row">{offset + index + 1}</th>
                                                                    <td> <NavLink to={`/field-visits/${row.id}/edit`}>{row.name}</NavLink></td>
                                                                    <td>{row?.label}</td>
                                                                    <td>{row?.price || "Not Set"}</td>
                                                                    <td>{row?.duration ||"Not Set" }</td>
                                                                    <td><span className={`badge bg-${row.status === 'active' ? 'success' : 'danger'}`}>{row.status || "Not Set"}</span></td>
                                                                    <td>{row?.level ||"Not Set" }</td>
                                                                    <td><Link to='' onClick={() => handleEditClick(row)}><FaEye /></Link> </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-center">No data available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <Pagination {...{ currentPage, totalPages, setCurrentPage }} className="pagination justify-content-end" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <ToastContainer />
            </>
  )
}

export default ListFieldVisit